import React from 'react'
import './CfoSite.css'
import { CfoBrandMark, CfoSiteFooter, navigateTo } from './CfoSiteShared'

const CAPABILITIES: { title: string; body: string }[] = [
  { title: 'Know if you can make payroll', body: 'See your cash weeks and months ahead, so a cash crunch never catches you off guard.' },
  { title: 'Get paid faster', body: 'See who owes you, who’s overdue, and who tends to pay late — and chase the right people first.' },
  { title: 'Know if you’re really making money', body: 'Your true profit and where it’s going, straight from your supported accounting platform — always current, no spreadsheets.' },
  { title: 'See how you’re doing', body: 'A plain-English health check each month, compared against businesses like yours.' },
  { title: 'Know what it’s worth', body: 'A credible estimate of your company’s value, ready for a buyer, bank, or board.' },
  { title: 'Look like you have a CFO', body: 'Turn the month into a polished, shareable report in a click — with a link for your bank or board.' },
]

const STEPS: { n: number; title: string; body: string }[] = [
  { n: 1, title: 'Create your account', body: 'A minute of basics — your name, company, and email. No spreadsheets, no setup call.' },
  { n: 2, title: 'Connect your books', body: 'Choose an available accounting platform and authorize securely. We read your books — we never write to them.' },
  { n: 3, title: 'Meet your CFO Core', body: 'We sync your full history and email you a private link to your live CFO Core the moment it’s ready.' },
]

export function CfoLandingPage() {
  const goSignup = () => navigateTo('/signup')
  const goLogin = () => navigateTo('/login')
  const goPricing = () => navigateTo('/pricing')
  return (
    <div className="cfo-site">
      <nav className="cfo-site-nav">
        <CfoBrandMark sub="by FuseGrid" />
        <div className="cfo-site-nav-links">
          <button className="cfo-btn cfo-btn-ghost" onClick={goPricing}>Pricing</button>
          <button className="cfo-btn cfo-btn-ghost" onClick={goLogin}>Sign in</button>
          <button className="cfo-btn cfo-btn-primary" onClick={goSignup}>Connect your books</button>
        </div>
      </nav>

      <header className="cfo-hero">
        <div className="cfo-wrap">
          <span className="cfo-eyebrow">For owner-operators — and the firms that serve them</span>
          <h1>Meet the <em>CFO</em> your accounting system always needed.</h1>
          <p className="lede">
            CFO Core reads your connected accounting books every day and tells you what changed, what needs your
            attention, and what to do about it — in plain English, answers first.
          </p>
          <div className="cfo-cta-row">
            <button className="cfo-btn cfo-btn-primary" onClick={goSignup}>Connect your books — free for 14 days →</button>
            <button className="cfo-btn cfo-btn-ghost" onClick={goLogin}>Sign in</button>
          </div>
          <div className="cfo-trust">
            <span>About a minute to sign up</span>
            <span>Every number traceable to its accounting source</span>
            <span>Read-only — we never write to your books</span>
          </div>
        </div>
      </header>

      <section className="cfo-section alt">
        <div className="cfo-wrap">
          <span className="cfo-eyebrow">How it works</span>
          <h2>From sign-up to a live CFO in three steps.</h2>
          <div className="cfo-grid cols-3">
            {STEPS.map((s) => (
              <div className="cfo-card" key={s.n}>
                <div className="cfo-step-n num">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cfo-section alt" aria-labelledby="provider-availability-heading">
        <div className="cfo-wrap">
          <span className="cfo-eyebrow">Accounting platforms</span>
          <h2 id="provider-availability-heading">One CFO Core, with an honest rollout status.</h2>
          <div className="cfo-provider-availability">
            <span><b>QuickBooks</b><em className="available">Full suite</em></span>
            <span><b>Xero</b><em className="available">Full suite</em></span>
            <span><b>Sage Accounting</b><em className="beta">Early access</em></span>
            <span><b>Sage Intacct</b><em>In development</em></span>
            <span><b>NetSuite</b><em>Planned</em></span>
          </div>
          <p className="cfo-provider-availability-note">Full suite means every deliverable runs on live books, with each month cross-checked to the penny against the provider&rsquo;s own reports before anything reaches you. Early access is the same suite, live for invited firms. Planned integrations are not yet available for live customer connections; their sample experiences do not imply live API support.</p>
        </div>
      </section>

      <section className="cfo-section">
        <div className="cfo-wrap">
          <span className="cfo-eyebrow">What it does for you</span>
          <h2>The questions every owner asks — answered.</h2>
          <div className="cfo-grid cols-3">
            {CAPABILITIES.map((c) => (
              <div className="cfo-card" key={c.title}>
                <h3>{c.title}</h3>
                <p>{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cfo-finalcta">
        <h2>Connect your accounting platform.</h2>
        <p>Start free — 14 days, no credit card. We’ll email you the moment your CFO Core is ready.</p>
        <button className="cfo-btn cfo-btn-primary" onClick={goSignup}>Connect your books — free →</button>
      </section>

      <CfoSiteFooter />
    </div>
  )
}

export default CfoLandingPage
